import { render, staticRenderFns } from "./ArchiveConInfos.vue?vue&type=template&id=544feda0&scoped=true"
import script from "./ArchiveConInfos.vue?vue&type=script&lang=js"
export * from "./ArchiveConInfos.vue?vue&type=script&lang=js"
import style0 from "./ArchiveConInfos.vue?vue&type=style&index=0&id=544feda0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544feda0",
  null
  
)

export default component.exports